import { AppsIcon, QuestionCircleIcon, TiendanubeIcon } from '@nimbus-ds/icons';

export const icons = {
  QuestionCircleIcon,
  AppsIcon,
  TiendanubeIcon,
};
